import React from "react";
import FeatureCard from "./FeatureCard";
import { FiPackage, FiUsers, FiCheckCircle, FiCalendar, FiAward, FiClipboard } from "react-icons/fi";

const FeaturesSection = () => {
  const features = [
    {
      icon: <FiPackage className="text-[#092162] text-3xl" />,
      title: "Job Posting",
      description:
        "Post jobs to multiple platforms simultaneously and reach the right candidates.",
    },
    {
      icon: <FiUsers className="text-[#092162] text-3xl" />,
      title: "Sourcing Candidates",
      description:
        "Automatically source and manage candidate profiles from various channels.",
    },
    {
      icon: <FiCheckCircle className="text-[#092162] text-3xl" />,
      title: "ATS & AI Evaluations",
      description:
        "Leverage AI to evaluate resumes and streamline candidate shortlisting.",
    },
    {
      icon: <FiCalendar className="text-[#092162] text-3xl" />,
      title: "Interviews",
      description:
        "Schedule, track, and manage interviews efficiently within the platform.",
    },
    {
      icon: <FiAward className="text-[#092162] text-3xl" />,
      title: "Offers",
      description:
        "Generate and send offer letters quickly, keeping candidates engaged.",
    },
    {
      icon: <FiClipboard className="text-[#092162] text-3xl" />,
      title: "Onboarding",
      description:
        "Seamlessly onboard new hires with digital forms and task tracking.",
    },
  ];

  return (
    <section className="w-full max-w-7xl mx-auto px-8 py-8">
  <h2 className="text-3xl font-bold text-center text-[#092162] mb-2">
    Features
  </h2>
  <p className="text-gray-600 text-center mb-8">
    Automate your entire recruitment process from posting to onboarding
  </p>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
    {features.map((f, idx) => (
      <FeatureCard key={idx} {...f} />
    ))}
  </div>
</section>
  );
};

export default FeaturesSection;
